import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-form-code" }
const _hoisted_2 = { class: "p-form-code__inputs" }
const _hoisted_3 = { class: "p-form-code__slot" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputCode = _resolveComponent("InputCode")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_InputCode, {
        modelValue: _ctx.code1,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.code1) = $event)),
        id: "code1",
        name: "code1",
        class: "p-form-code__input",
        onKeypress: _cache[1] || (_cache[1] = ($event: any) => (_ctx.keypressed(2))),
        onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateValue(2)))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_InputCode, {
        modelValue: _ctx.code2,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.code2) = $event)),
        name: "code2",
        ref: "code2",
        class: "p-form-code__input",
        onKeypress: _cache[4] || (_cache[4] = ($event: any) => (_ctx.keypressed(3))),
        onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateValue(3)))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_InputCode, {
        modelValue: _ctx.code3,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.code3) = $event)),
        name: "code3",
        ref: "code3",
        class: "p-form-code__input",
        onKeypress: _cache[7] || (_cache[7] = ($event: any) => (_ctx.keypressed(4))),
        onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateValue(4)))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_InputCode, {
        modelValue: _ctx.code4,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.code4) = $event)),
        name: "code4",
        ref: "code4",
        class: "p-form-code__input",
        onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateValue(0)))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ]))
}